import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyAddressAllResponse, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { RegisterMemberNewPayload } from "../../../models/member.model";
import { ParkingCardInfo, Providers, StatusAPIResponse } from "../../../models/information.model";
import { ObjectFeeResponse } from "../../../models/parking.model";
import { CityParkingDiscountByCodeResponse, MasterProviders } from "../../../models/discount.model";

@Injectable({
  providedIn: 'root',
})

export class ApiProviderService {
  private tokenUrl = `${environment.apiPrivateUrl}`;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private apiMethods: ApiMethodService,
  ) { }

  getProviders(): Observable<Providers[]> {
    return this.http.get<Providers[]>(this.tokenUrl + '/Cityparking/GetProviders');
  }

  GetProvidersDiscount(token: string): Observable<MasterProviders[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<MasterProviders[]>(
      this.tokenUrl + '/Cityparking/GetProvidersDiscount',
      { headers },
    );
  }


}

